import React from 'react'
import { navigateTo } from 'gatsby-link'
import styled, { css } from 'styled-components'
import { VelocityComponent } from 'velocity-react'
import Link from 'gatsby-link'
import moment from 'moment'

import { warmBrown } from '../../../styles/themes'
import { media } from '../../../styles/utils'
import { container, innerContainer, bgIcon, padding, hoverState, bgImage } from '../../../styles/global'
import { grey } from '../../../styles/colors'
import { heading2, paragraph, caption } from '../../../styles/type'

class BlockContact extends React.Component {

	state = {
	
    }
    
    resolveDetailsValue = (detail) => {

        const resolveURL = (detail) => {
            let urltext = detail.value_url_text;
            if (!urltext) urltext = detail.value_url;
            return <DetailValueLink href={detail.value_url}>{urltext}</DetailValueLink>
        }
        
        const details = {
            'text': <DetailValue>{detail.value_text}</DetailValue>,
            'email': <DetailValueLink href={`mailto:${detail.value_email}`}>{detail.value_email}</DetailValueLink>,
            'url': resolveURL(detail),
            'phone': <DetailValueLink href={`tel:${detail.value_phone}`}>{detail.value_phone}</DetailValueLink>,
        }
        
        return details[detail.value_type]
    }

	renderDetails = () => {
        const { details } = this.props;
        
        const items = details.map((detail, i) => {
            return (
                <Detail
                    key={i}
                >
                    <Title>{detail.title}</Title>
                    &nbsp;
                    <Value>{this.resolveDetailsValue(detail)}</Value>
                </Detail>
            )
        })   
        return (
            <Details>{items}</Details>
        )
	}
	
	render() {
        const { address, extra_text, show_copyright_and_credits, google_maps_link } = this.props;

        let copyright_credits;
        if (show_copyright_and_credits) {
            const year = moment().year();
            copyright_credits = `© Paul Conrad Architects ${year}<br/>
            Website by <a href="http://three60.com.au" target="_blank">Three60</a> & <a href="https://www.morebymore.com.au/" target="_blank">More Studio</a>`
        }
        
		return (
            <Info>

                {/* <Left>
                    <Heading>Contact</Heading>
                    
                    {show_copyright_and_credits && (
                        <CopyrightCredits
                            dangerouslySetInnerHTML={{__html: copyright_credits}}  
                        />
                        
                    )}
                </Left>     */}
                
                <Content>
                    <Heading>Contact</Heading>

                    {address && (
                        <Address
                            dangerouslySetInnerHTML={{__html: address}}  
                            href={google_maps_link}
                            target="_blank"
                        />      
                    )}

                    {this.renderDetails()}

                    {extra_text && (
                        <ExtraText
                            dangerouslySetInnerHTML={{__html: extra_text}}  
                        />
                    )}
                </Content>
            </Info>
		)
	}
}



// Info

// const Left = styled.div`
//     flex: 0 1 50%;
//     display: flex;
//     flex-direction: column;
//     align-items: space-between;
// `

const Heading = styled.div`
    font-family: 'Scto';
    font-weight: 300;
    font-size: 20px;
    line-height: 24px;
    color: ${grey};
    margin-bottom: 50px;

    ${media.phone`
        font-size: 18px;
        line-height: 18px;
    `}
`

const CopyrightCredits = styled.div`
    margin-top: auto;

    ${media.phone`
        display: none;
    `}

    &, *, a {
        ${caption};
        color: rgba(89,88,80,0.5);
        text-indent: 0 !important;
    }

    a {
        transition: 0.15s color ease;
        &:hover {
            color: rgba(89,88,80,1);
        }
    }
`

const Content = styled.div``


// Info layout

const Info = styled.div`
	${innerContainer};
	display: flex;

	${media.phone`
		flex-direction: column;
	`} 

	${Heading}, ${Content} {
		flex: 50%;
		box-sizing: border-box;

		${media.phone`
			flex: none;
			width: 360px;
			max-width: 100%;
		`}
	}

	${Heading} {
		/* half gutter size */
		/* padding-right: 2.5rem; */

		${media.phone`
			margin-bottom: 3rem;
			padding-right: 0;
		`}
	}

	${Content} {
		/* half gutter size */
		padding-left: 2.5rem;
        padding-right: 2.5rem;

		${media.phone`
			padding-left: 0;
		`}
	}
`

const Address = styled.a`
    ${paragraph};
    ${hoverState};
    cursor: pointer;
`

// Details
const Details = styled.div`
    margin-top: 2rem;
`

const Title = styled.div``
const Value = styled.div``
const DetailValue = styled.div``
const DetailValueLink = styled.a`
    ${hoverState};
`

const Detail = styled.div`
    display: flex;

    ${Title}, ${Value} ${DetailValue}, ${DetailValueLink} {
        &, > * {
            ${paragraph};
            text-indent: 0!important;
        }
    }

    ${Title} {
        color: rgba(89, 88, 80, 0.6)!important;   
    }
`


// Extra Text
const ExtraText = styled.div`
    width: 315px;
    max-width: 100%;
    margin-top: 10rem;

    ${media.laptop`
        width: 235px;
    `}

    ${media.phone`
        margin-top: 5rem;
    `}

    > * {
        ${caption};
        color: rgba(89,88,80,0.50)!important;
    }

    a {
        color: ${grey};
        ${hoverState};
    }
`


BlockContact.wrapper = css`
    display: flex;
    flex-direction: column;
    align-items: center;
`

export default BlockContact



// WEBPACK FOOTER //
// ./src/components/Block/templates/BlockContact.js